export const WEBSOCKET_CONFIG = {
  url: process.env.NX_COURIER_WSS,
  reconnection: {
    initialDelay: 1000,
    maxDelay: 32000,
    backoffMultiplier: 2,
    maxAttempts: Infinity
  },
  connection: {
    timeout: 10000,
    pingInterval: 30000,
    pongTimeout: 5000
  },
  data: {
    maxMessages: 1_000,
    filterDebounceMs: 500
  }
} as const;

export const WEBSOCKET_CLOSE_CODES = {
  NORMAL: 1000,
  GOING_AWAY: 1001,
  PROTOCOL_ERROR: 1002,
  UNSUPPORTED: 1003,
  ABNORMAL: 1006,
  POLICY_VIOLATION: 1008,
  MESSAGE_TOO_BIG: 1009,
  EXTENSION_REQUIRED: 1010,
  SERVER_ERROR: 1011
} as const;

export const WEBSOCKET_READY_STATES = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3
} as const;
